import {
  TOGGLE_THEME,
  TOGGLE_THEME_DEFAULT,
  DISPLAY_SNACKBAR,
  CLOSE_SNACKBAR,
  SET_USER_ACCESS,
  CLEAR_USER_ACCESS,
  ADD_TASK_TO_TASKLIST,
  UPDATE_TASK_IN_TASKLIST,
  REMOVE_TASK_FROM_TASKLIST,
  POLL_TASKS,
  SET_TASK_LIST,
  SWITCH_LANGUAGE
} from "../constants/actionTypes";

export const switchTheme = (theme) => ({
  type: TOGGLE_THEME,
  payload: theme
});

export const switchThemeDefault = (themeVal) => ({
  type: TOGGLE_THEME_DEFAULT,
  payload: {
    theme: themeVal,
  }
});

export const displaySnackbar = (message, type) => ({
  type: DISPLAY_SNACKBAR,
  payload: {
    message: message,
    type: type
  }
});
export const closeSnackbar = () => ({
  type: CLOSE_SNACKBAR
});

export const SetUserAccess = (token, accountName, role,customerID,accessID,dateTime) => ({
  type: SET_USER_ACCESS,
  payload: {
    token: token,
    accountName: accountName,
    userRole: role,
    customerID: customerID,
    accessID: accessID,
    LoginDate: dateTime
  }
});

export const ClearUserAccess = () => ({
  type: CLEAR_USER_ACCESS
});

export const AddTaskToTaskList = item => ({
  type: ADD_TASK_TO_TASKLIST,
  payload: item
});

export const UpdateTaskInTaskList = (item, itemIndex) => ({
  type: UPDATE_TASK_IN_TASKLIST,
  index: itemIndex,
  payload: item
});

export const RemoveTaskFromTaskList = taskId => ({
  type: REMOVE_TASK_FROM_TASKLIST,
  payload: taskId
});

export const SetTaskList = itemArray => ({
  type: SET_TASK_LIST,
  payload: itemArray
});

export const ChangeLanguage = newLang => ({
  type: SWITCH_LANGUAGE,
  payload: newLang
});
